export default __webpack_public_path__ + "static/media/04.f42f25ee.jpg";